import { ProductSet } from "@common/index";

export const productData: ProductSet = {
    "descriptionHtml": "no description",
    "files": [
        {
            "alt": "Reusable Water Balloons Toys Quick Fill Self Sealing Water Bomb for Summer Games Children's Adults Outdoor Activities Toy Gifts",
            "contentType": "IMAGE",
            "filename": "S8c2853733ed14dbc8b59163b656cc656T.png",
            "originalSource": "https://cdn.bustly.shop/static/noProduct.png"
        },
        {
            "alt": "Reusable Water Balloons Toys Quick Fill Self Sealing Water Bomb for Summer Games Children's Adults Outdoor Activities Toy Gifts",
            "contentType": "IMAGE",
            "filename": "S43da3d87d64748bab6951a60caa6f933a.jpg",
            "originalSource": "https://cdn.bustly.shop/static/noProduct.png"
        },
        {
            "alt": "Reusable Water Balloons Toys Quick Fill Self Sealing Water Bomb for Summer Games Children's Adults Outdoor Activities Toy Gifts",
            "contentType": "IMAGE",
            "filename": "Sb110b2ae55fc47d4b365a5137bcfac12y.jpg",
            "originalSource": "https://cdn.bustly.shop/static/noProduct.png"
        },
        {
            "alt": "Reusable Water Balloons Toys Quick Fill Self Sealing Water Bomb for Summer Games Children's Adults Outdoor Activities Toy Gifts",
            "contentType": "IMAGE",
            "filename": "Sa5bcada30f1b410282db31f66cacb212U.jpg",
            "originalSource": "https://cdn.bustly.shop/static/noProduct.png"
        },
        {
            "alt": "Reusable Water Balloons Toys Quick Fill Self Sealing Water Bomb for Summer Games Children's Adults Outdoor Activities Toy Gifts",
            "contentType": "IMAGE",
            "filename": "Se56ec9a677634ed5b1959b659df5de8et.jpg",
            "originalSource": "https://cdn.bustly.shop/static/noProduct.png"
        }
    ],
    "productOptions": [
        {
            "name": "Color",
            "position": 1,
            "values": [
                {"name": "Random color"}
            ]
        },
        {
            "name": "Ballon Size",
            "position": 2,
            "values": [
                {"name": "6pcs"},
                {"name": "18pcs"},
                {"name": "12pcs"}
            ]
        }
    ],
    "title": "Reusable Water Balloons Toys Quick Fill Self Sealing Water Bomb for Summer Games Children's Adults Outdoor Activities Toy Gifts",
    "variants": [
        {
            "price": 27.66,
            "sku": "12000048649520495",
            "optionValues": [
                {
                    "name": "Random color",
                    "optionName": "Color"
                },
                {
                    "name": "12pcs",
                    "optionName": "Ballon Size"
                }
            ],
            "file": {
                "alt": "Reusable Water Balloons Toys Quick Fill Self Sealing Water Bomb for Summer Games Children's Adults Outdoor Activities Toy Gifts - Color Random color",
                "contentType": "IMAGE",
                "filename": "Sbed8ffc106474a5ea3f9b8bc9305e6f9O.jpg",
                "originalSource": "https://cdn.salerio.shop/static/noProduct.png"
            }
        },
        {
            "price": 15.55,
            "sku": "12000048649520494",
            "optionValues": [
                {
                    "name": "Random color",
                    "optionName": "Color"
                },
                {
                    "name": "6pcs",
                    "optionName": "Ballon Size"
                }
            ],
            "file": {
                "alt": "Reusable Water Balloons Toys Quick Fill Self Sealing Water Bomb for Summer Games Children's Adults Outdoor Activities Toy Gifts - Color Random color",
                "contentType": "IMAGE",
                "filename": "Sbed8ffc106474a5ea3f9b8bc9305e6f9O.jpg",
                "originalSource": "https://cdn.salerio.shop/static/noProduct.png"
            }
        },
        {
            "price": 41.49,
            "sku": "12000048649520496",
            "optionValues": [
                {
                    "name": "Random color",
                    "optionName": "Color"
                },
                {
                    "name": "18pcs",
                    "optionName": "Ballon Size"
                }
            ],
            "file": {
                "alt": "Reusable Water Balloons Toys Quick Fill Self Sealing Water Bomb for Summer Games Children's Adults Outdoor Activities Toy Gifts - Color Random color",
                "contentType": "IMAGE",
                "filename": "Sbed8ffc106474a5ea3f9b8bc9305e6f9O.jpg",
                "originalSource": "https://cdn.salerio.shop/static/noProduct.png"
            }
        }
    ],
    "metafields":[{
        "namespace": "bustly",
        "key": "product_settings",
        "type": "json",
        "value": `{
            "rating": 4.9,
            "rating_count": 234,
            "brief_description": "This is a brief description of the product.",
            "advantages": [
                "This is a advantage of the product.(Within 20 words)",
                "This is a advantage of the product.(Within 20 words)",
                "This is a advantage of the product.(Within 20 words)"
            ],
            "highlight_block": {
                "title": "Highlight title",
                "sub_title": "Highlight sub title",
                "summary": "This is a highlight summary of the product.",
                "details": [
                    "This is a highlight detail of the product.(Within 20 words)",
                    "This is a highlight detail of the product.(Within 20 words)",
                    "This is a highlight detail of the product.(Within 20 words)"
                ]
            },
            "features": {
                "title": "Features title",
                "sub_title": "This is a sub title of the features.(Within 10 words)",
                "description": "This is a description of the features.",
                "blocks": [
                    {
                        "description": "This is a description of the features.",
                        "img": "https://ae01.alicdn.com/kf/S58272816cd9649d9a49de8538801d182Q.jpg"
                    },
                    {
                        "description": "This is a description of the features.",
                        "img": "https://ae01.alicdn.com/kf/S58272816cd9649d9a49de8538801d182Q.jpg"
                    }
                ]
            },
            "reviews": [{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            },{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            },{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            },{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            },{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            },{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            },{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            },{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            },{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            },{
                "content": "This is a content of the reviews.",
                "avatar": "",
                "name": "John Doe"
            }]
        }`
    }]
}